import { Product } from 'api/dbs/models';
import messages from 'messages';

type TranslationReturn = [string, { period: number }] | undefined;

const KEYS = {
  day: messages.dayTerm,
  week: messages.weekTerm,
  month: messages.monthTerm,
  year: messages.yearTerm,
  days: messages.daysTerm,
  weeks: messages.weeksTerm,
  months: messages.monthsTerm,
  years: messages.yearsTerm,
  yearsPL: messages.yearsTermPL,
};

export const getMaturiyTranslationMessage = (
  product: Product,
  locale?: string,
): TranslationReturn => {
  if (!product.term) {
    return undefined;
  }
  const {
    term: { unit, period },
  } = product;
  const isYearConvertable = unit === 'months' && period > 11 && period % 6 === 0;
  if (!isYearConvertable) {
    const pluralKeys = {
      days: KEYS.days,
      weeks: KEYS.weeks,
      months: KEYS.months,
      years: KEYS.years,
    };
    const key = period > 1 ? pluralKeys[unit] : KEYS[unit];
    return [key, { period }];
  }
  const yearPeriod = period / 12;

  // handling custom key for years >= 5 for PL language
  if (yearPeriod >= 5 && locale === 'pl-PL') {
    return [KEYS.yearsPL, { period: yearPeriod }];
  }

  return [yearPeriod > 1 ? KEYS.years : KEYS.year, { period: yearPeriod }];
};
